import React from 'react';
import MoreLink from 'commonComponents/MoreLink/MoreLink';
import styles from './BaseTile.module.scss';

const BaseTile = ({
  name,
  photo,
  logo,
  title,
  text,
  link,
  isMore,
  content,
  additionalClass
}) => {
  const classes = `${styles.BaseTile} ${additionalClass ? styles[additionalClass] : ''}`;
  const defaultProps = { logo, title, text, link, isMore };
  const defaultContent = <BaseContent { ...defaultProps } />;

  return ( 
    <div className={ classes }>
      { photo && 
        <img src={ photo } alt={ name }
          className={ styles.photo }
        /> }
      { content || defaultContent }
    </div>
  );
};

const BaseContent = ({
  logo,
  title,
  text,
  link,
  isMore
}) => {
  return (
    <>
      { logo &&
        <figure className={ styles.logo } >
          <img src={ logo } alt={ name } />
        </figure>
      }
      { title && <h5>{ title }</h5> }
      <p className={ styles.text }>
        { text } { isMore && <MoreLink url={ link } />}
      </p>
    </>
  );
};

export default BaseTile;
